import type { Commodity } from '@enmon/commons/lib/shared';

export const INVENTORIZE_EXTRACTION_BACKEND_STATUSES = {
  completed: 'completed',
  created: 'created',
  failed: 'failed',
  running: 'running',
} as const;

export type InventorizeExtractionBackendStatus =
  (typeof INVENTORIZE_EXTRACTION_BACKEND_STATUSES)[keyof typeof INVENTORIZE_EXTRACTION_BACKEND_STATUSES];

export interface InventorizeExtractionError {
  code: string;
  message: string;
}

export interface InventorizeExtractionRegister {
  name?: string | null;
  obis?: string | null;
  photoRef?: string | null;
  reading_counter?: number | string | null;
  unit?: string | null;
}

export interface PartialInventorizationExtraction {
  calibrated?: number | string | null;
  detail?: Record<string, unknown> | null;
  fieldConfidence?: Record<string, number>;
  manufacturer?: number | string | { id?: number | null; text?: string | null } | null;
  meterModel?: string | { id?: number | null; text?: string | null } | null;
  meter_mount_technology?: string | null;
  meter_mount_type?: string | null;
  manufactured?: number | string | null;
  registers?: InventorizeExtractionRegister[];
  remote_reading_serial?: string | null;
  serial?: string | null;
  warnings?: string[];
}

export interface InventorizeExtractionJobData {
  commodity?: Commodity;
  error?: InventorizeExtractionError;
  jobId: string;
  result?: PartialInventorizationExtraction;
  status: InventorizeExtractionBackendStatus;
}

export interface InventorizeExtractionJobResponse {
  data: InventorizeExtractionJobData;
}

export interface ServerInventorizeExtractionJobOutput {
  backendStatus: InventorizeExtractionBackendStatus;
  error?: InventorizeExtractionError;
  jobId: string;
  mode: 'server_job';
  photoIds: string[];
  result?: PartialInventorizationExtraction;
}
